const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function formatGraceDeadline(iso: string | null | undefined): string | null {
  if (!iso) return null;

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;

  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function getGraceDaysRemaining(iso: string | null | undefined): number | null {
  if (!iso) return null;

  const graceEndsAt = new Date(iso).getTime();
  if (Number.isNaN(graceEndsAt)) return null;

  return Math.max(0, Math.ceil((graceEndsAt - Date.now()) / MS_PER_DAY));
}
